module.exports = __webpack_public_path__ + "static/img/3-info-b2.daa5c5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b2.jpg
// module id = vo70
// module chunks = 0